import axios from 'axios'
import {
  baseURL
} from 'config'
import {
  jwtConfig
} from 'helpers/RequestUtil'
import {
  take,
  takeLatest,
  fork,
  all,
  select,
  cancel,
  cancelled,
  call,
  put,
} from 'redux-saga/effects'
import * as R from 'ramda'
import { segmentSelector } from 'containers/Project/View/selectors'

import loadCommentSagas from 'containers/Project/GreenlightCommentSection/sagas'
import loadReportSagas from 'containers/Project/GreenlightReport/sagas'
import {
  MOUNT,
  UNMOUNT,
} from './constants'
import {
  UPDATE_REVISIONS,
  FETCH_REVISIONS_SUCCESS,
  FETCH_REVISIONS_ERROR,
  UPDATE_CURRENT_REVISION
} from 'containers/Project/GreenlightReport/constants'
import {
  POST_FASTTRACK
} from './constants'
import {
  UPDATE_PROJECT_INFO,
} from 'containers/Project/View/constants'
import {
  fetchComments,
} from 'containers/Project/GreenlightCommentSection/actions'
import {
  fetchRevisions,
  changeRevision,
} from 'containers/Project/GreenlightReport/actions'
import {
  projectIdSelector,
} from 'containers/Project/View/selectors'
import {
  sourceProjectRevisionSelector,
  nextRevisionIdSelector
} from 'containers/Project/GreenlightSection/selectors'
import {
  nameSelector
} from 'containers/User/Login/selectors'
import {
  isClientSelector
} from 'containers/Role/Global/selectors'
import {
  postFastTrackStart,
  postFastTrackSuccess,
  postFastTrackError,
  startpostFastTrackAsync
} from './actions'

function* handleRevisionChange(action) {
  const { revision } = action
  const projectId = yield select(projectIdSelector)
  yield put(fetchComments(projectId, revision))
}

function* watchRevisionChange() {
  yield takeLatest(UPDATE_CURRENT_REVISION, handleRevisionChange)
}

function* fetchInitialRevisions() {
  const getRevision = R.compose(
    R.reduce(R.max, null),
    R.keys
  )
  const projectId = yield select(projectIdSelector)
  yield put(fetchRevisions(projectId))

  const action = yield take([FETCH_REVISIONS_SUCCESS, FETCH_REVISIONS_ERROR])
  if (action.type === FETCH_REVISIONS_SUCCESS) {
    const { revisions } = yield take(UPDATE_REVISIONS)
    const revision = getRevision(revisions)
    if (revision) {
      yield put(changeRevision(revision))
    }
  }
}

function* postFastTrackRevision(action) {
  try {
    yield put(startpostFastTrackAsync())
    yield put(postFastTrackStart())
    const { projectId, sourceProjectId } = action
    const revision = yield select(nextRevisionIdSelector)
    const sourceRevision = yield select(sourceProjectRevisionSelector)
    const name = yield select(nameSelector)

    const body = {
      projectId: projectId,
      revision: revision,
      sourceProjectId: sourceProjectId,
      sourceRevision: sourceRevision,
      fastTrackedBy: name
    }

    yield call(
      axios.post,
      `${baseURL}/api/fts/fastTrackReport`,
      body,
      jwtConfig()
    )

    yield call(fetchInitialRevisions)
    yield put(postFastTrackSuccess())
    location.reload()
  } catch (error) {
    yield put(postFastTrackError(error))
    return {}
  }
}

function* watchPostFastTrack() {
  yield takeLatest(POST_FASTTRACK, postFastTrackRevision)
}

function* watchMount() {
  // watch mount and unmount
  // only when project detail and mount is done than you should load first
  let isProjectLoaded = false,
    isMounted = false,
    tasks = [],
    isClient = true

  while (true) {
    let { type } = yield take([UPDATE_PROJECT_INFO, MOUNT, UNMOUNT])
    if (type === UNMOUNT) {
      isProjectLoaded = false
      isMounted = false
    } else if (type === MOUNT) {
      isMounted = true
    } else if (type === UPDATE_PROJECT_INFO) {
      isProjectLoaded = true
    }

    if (isProjectLoaded && isMounted) {
      const segment = yield select(segmentSelector)
      isClient = yield select(isClientSelector)
      let sagas = [loadReportSagas, watchRevisionChange]
      if (!isClient) sagas.push(loadCommentSagas)
      tasks = yield all(sagas.map(saga => fork(saga)))
      if (segment !== 'Enterprise') {
        let task = yield fork(fetchInitialRevisions)
        tasks.push(task)
      }
    } else {
      if (tasks.length > 0) {
        yield cancel(...tasks)
        tasks = []
      }
    }
  }
}

function* loadSagas() {
  yield all([
    fork(watchMount),
    fork(watchPostFastTrack)
  ])
}

export default loadSagas
